import { ACTION_ENDPOINT_PATH } from '@/common/actionProtocol/ActionProtocol';
import { paths } from '@/common/app/paths';
async function readJson(response) {
    try {
        return await response.json();
    }
    catch {
        return undefined;
    }
}
/**
 * Browser transport for the v2 protocol.
 *
 * POST uses the frozen /player/input/v2 endpoint. The full resync repeats the
 * legacy authorized GET api/player query, preserving serverId and replacing
 * only the id parameter.
 */
export class HttpGameShellTransport {
    constructor(fetchImpl) {
        this.fetchImpl = fetchImpl ?? ((input, init) => fetch(input, init));
    }
    async post(request) {
        const response = await this.fetchImpl(ACTION_ENDPOINT_PATH, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request),
        });
        return {
            statusCode: response.status,
            body: await readJson(response),
        };
    }
    async fetchBootstrap(playerId) {
        const response = await this.fetchImpl(this.bootstrapUrl(playerId), {
            method: 'GET',
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' },
        });
        if (!response.ok) {
            return undefined;
        }
        return await readJson(response);
    }
    bootstrapUrl(playerId) {
        if (typeof window === 'undefined') {
            return paths.PLAYER_BOOTSTRAP_V2 + '?id=' + encodeURIComponent(playerId);
        }
        const params = new URLSearchParams(window.location.search);
        params.delete('noredirect');
        params.set('id', playerId);
        return paths.PLAYER_BOOTSTRAP_V2 + '?' + params.toString();
    }
    async fetchPlayerView(playerId) {
        const response = await this.fetchImpl(this.playerViewUrl(playerId), {
            method: 'GET',
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' },
        });
        if (!response.ok) {
            throw new Error('player resync failed with HTTP ' + response.status);
        }
        return await response.json();
    }
    playerViewUrl(playerId) {
        if (typeof window === 'undefined') {
            if (playerId === undefined) {
                throw new Error('player resync needs a player id outside a browser');
            }
            return paths.API_PLAYER + '?id=' + encodeURIComponent(playerId);
        }
        const params = new URLSearchParams(window.location.search);
        params.delete('noredirect');
        if (playerId !== undefined) {
            params.set('id', playerId);
        }
        const query = params.toString();
        return query === '' ? paths.API_PLAYER : paths.API_PLAYER + '?' + query;
    }
}
